'use strict';

import raven from 'raven';
import angular from 'angular';
import Config from 'config';
import FormController from 'app/controllers/form';
import AddProcedureController from './add-procedure.controller';
import AddProcedureTpl from './add-procedure.html';
import NewVehicleController from './new-vehicle.controller';
import NewVehicleTpl from './new-vehicle.html';
import AddSpendingController from './add-spending.controller';
import AddSpendingTpl from './add-spending.html';

class QuoteController extends FormController {
    /* @ngInject */
    constructor(
        QuotesService,
        ClientsService,
        VehiclesService,
        ProceduresService,
        ItemsService,
        OperativeSpendingsService,
        LoopBackAuth,
        $mdExpansionPanel,
        $scope, $window, $mdDialog, $mdMenu, $location, $mdToast, focus,
        $rootScope, $state, $stateParams
    ) {
        let quote = $scope.$parent.$resolve.quote;
        super(quote, 'Presupuesto', QuotesService, focus, 'quotes');
        this.procedureTemplates = $scope.$parent.$resolve.procedureTemplates;
        this.user = $scope.$parent.$resolve.user;
        // Required when manually adding items
        this.itemTemplates = $scope.$parent.$resolve.itemTemplates;

        Object.assign(this, {
            QuotesService,
            ClientsService,
            VehiclesService,
            ProceduresService,
            ItemsService,
            OperativeSpendingsService,
            LoopBackAuth,
            $mdExpansionPanel,
            $scope, $window, $mdDialog, $mdMenu, $location, $mdToast,
            $rootScope,
            $state
        });

        this.client = this.model.client;
        this.holder = this.model.holder;
        this.vehicle = this.model.vehicle;
        this.procedures = this.model.procedures || [];
        this.receipts = this.model.receipts || [];
        this.operativeSpendings = this.model.operativeSpendings || [];
        this.pendingOperativeSpendings = this.model.pendingOperativeSpendings
            || [];
        this.createdByUser = this.model.createdByUser;
        this.updatedByUser = this.model.updatedByUser;
        /* avoid circular ref error on save() because unsaved procedures
           contain a reference to the quote */
        delete this.model.procedures;

        this.items = {};
        this.procedures.forEach(p => {
            this.items[p.id] = p.items;
            delete p.items;
        });
        this.itemSaves = [];

        // hack: to be displayed on vehicle autocomplete
        if (this.vehicle)
            this.vehicle.fullDesc = `${this.vehicle.plate} - \
${this.vehicle.number} - ${this.vehicle.description}`;

        if ($stateParams.editing) {
            this.editing = true;
            this.editable = false;
        }

        this.potentialHolders = this.holder ? [this.holder] : [];
        this.potentialClients = this.client ? [this.client] : [];

        this.selectedProcedures = {};
        this.selectedProceduresList = [];
    }

    onHolderFilterUpdate($event) {
        $event.clientsPromise.then(holders => {
            this.potentialHolders = holders;

            const sameClientsHolders = holders.filter(
                h => this.potentialClients.some(c => c.id == h.id)
            );
            const doReplace = !this.potentialClients.length ||
                  sameClientsHolders.length == holders.length;
            if (doReplace) {
                this.potentialClients = holders;
            }
        });
    }

    onClientFilterUpdate($event) {
        $event.clientsPromise.then(clients => {
            this.potentialClients = clients;
        });
    }

    getItemById(itemId) {
        let procedureIds = Object.keys(this.items);
        for (let pId of procedureIds) {
            let procedureItems = this.items[pId];
            let item = procedureItems.find(item => item.id == itemId);
            if (item) return item;
        }
    }

    $onInit() {
        super.$onInit();

        if (this.model.approvedAt) {
            this.modelName = 'Orden de trabajo';
        }

        const toAssociate = this.$scope.$parent.$resolve.associatingSpending
              && !this.model.groupInvoiceId;
        if (toAssociate) {
            this.editing = true;
            this.editable = false;
            this.associatingSpending =
                this.$scope.$parent.$resolve.associatingSpending;
            this.associatingSpendingItems = {};
            this.totalAssociatedAmount = 0;
            this.cannotSave = true;
            this.$scope.$broadcast('associationStart');
        }

        if (this.model.groupInvoiceId) {
            this.neverEditable = true;
        }
    }

    queryClientSearch(text) {
        return this.ClientsService.findByText(text);
    }

    queryVehicleSearch() {
        return this.VehiclesService.getModels({
            where: {
                broad: this.searchVehicleText
            },
            order: 'plate DESC, number DESC, description DESC'
        }).then(vehicles => {
            return vehicles.map(v => {
                v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
                return v;
            });
        });
    }

    selectedClientChange() {
        this.model.clientId = this.client.id;
    }

    selectedHolderChange() {
        this.model.holderId = this.holder.id;

        if (!this.client) {
            this.client = this.holder;
            this.potentialClients = [this.client];
            this.model.clientId = this.holder.id;
        }
    }

    selectedVehicleChange(vehicle) {
        if (!vehicle) {
            return;
        }

        this.vehicle = vehicle;
        this.model.vehicleId = vehicle.id;

        // Allow angular to update form validity status
        setTimeout(() => {
            if (!this.model.id && this.form.$valid) {
                this.QuotesService.find({
                    filter: {
                        where: {
                          ...(this.holder ? {holderId: this.holder.id} : {}),
                          ...(this.vehicle ? {vehicleId: this.vehicle.id} : {}),
                        }
                    }
                }).then((existingQuotes) => {
                    let quote = existingQuotes.length
                        ? existingQuotes[0] : null;
                    return Promise.resolve().then(() => {
                        if (quote) {
                            let confirm = this.$mdDialog.confirm()
                                .title('Desea crear el presupuesto de todas maneras?')
                                .textContent(`Atención: Ya existe un presupuesto/OT \
para mismo titular y dominio, desea crear el presupuesto igual?`)
                                .ok(`Sí, crearlo de todas maneras`)
                                .cancel('Cancelar e ir al presupuesto ya existente');

                            return this.$mdDialog.show(confirm);
                        }
                    }).then(() => {
                        this.save().then(() => {
                            this.editable = false;
                            this.editing = true;
                        });
                    }, () => {
                        this.$state.go('editQuote', {
                            id: quote.id
                        });
                    });
                });
            } else {
                // console.debug(this.form);
            }
        }, 0);

    }

    save(ev) {
        if (!this.form.$valid) {
            this.simpleError(`No se pudo guardar el presupuesto,
por favor controle el formulario.`);
            return Promise.reject();
        }
        let firstTimeSave = this.model.id ? false : true;
        /* item saves should be already resolved but it's not a bad idea
         to wait for them anyway */
        let waitForEverybody = Promise.all(this.itemSaves);
        this.showSpin = true;
        return waitForEverybody.then(() => {
            return this.saveProcedures();
        }).then(() => {
            return this.model.$save();
        }).then(() => {
            this.updatedByUser = this.user;
            this.showSpin = false;
            this.editable = true;
            this.editing = false;
            if (firstTimeSave) {
                this.$state.go(
                    'edit' + this.Service.Model.modelName,
                    {
                        id: this.model.id,
                        editing: true
                    }
                );
            }
            this.simpleSuccess(`OT/Presupuesto guardado correctamente`);
        }, err => {
          // console.error(err);
          raven.captureException(new Error(err));
          this.simpleError();
        });
    }

    saveProcedures() {
        return Promise.all(
            this.procedures
                .filter(p => !p.markedForDeletion)
                .map(
                    p => this.ProceduresService.save(p)
                )
        );
    }

    addProcedure(ev) {
        this.$mdDialog.show({
            controller: AddProcedureController,
            template: AddProcedureTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen, // Only for -xs, -sm breakpoints.,
            locals: {
                procedureTemplates: this.procedureTemplates
            }
        }).then(data => {
            return this.QuotesService.createProcedureFromTpl({
                quote: this.model,
                procedureTemplate: data.procedureTpl
            });
        }).then(res => {
            res.procedures.forEach(p => {
                if (p.items) {
                    this.items[p.id] = p.items;
                    delete p.items;
                }
                this.procedures.push(p);
                this.$mdExpansionPanel().waitFor('procedure-' + p.id)
                    .then((panel) => {
                        panel.expand();
                    });
            });
            this.simpleSuccess(`Tramite agregado correctamente`);
        }, err => {
            if (err) {
                raven.captureException(err);
                this.simpleError();
            }
        });
    }

    onProcedureDelete($event) {
        let procedure = $event.model;

        if (procedure.id) {
            let id = procedure.id;
            this.ProceduresService.destroyById(id).then(() => {
                delete this.items[id];
                this.simpleSuccess(`Tramite eliminado correctamente`);
                procedure.markedForDeletion = true;
            }, err => {
                this.simpleError();
            });

        } else {
            procedure.markedForDeletion = true;
        }
    }

    onItemSave($event) {
        this.itemSaves.push($event.promise);
    }

    approve() {
        let confirm = this.$mdDialog.confirm()
            .title('Aviso importante')
            .textContent(`Usted está aprobando un presupuesto y automáticamente \
va a generar una orden de trabajo, con lo cual necesariamente deberá informar \
ingresos y egresos. Desea continuar?`)
            .ok(`Aceptar`)
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(() => {
            this.showApproveSpin = true;
            this.QuotesService.Model.approve({
                id: this.model.id
            }).$promise.then(res => {
                this.showApproveSpin = false;
                this.procedures.forEach(procedure => {
                    let items = this.items[procedure.id];
                    items.forEach(item => {
                        item.finalCost = 0;
                        item.finalPrice = item.price;
                    });
                });
                Object.assign(this.model, res.quote);
            }, err => {
                this.showApproveSpin = false;
                let msg;
                if (err.data.error.code === 'QUOTE_ALREADY_APPROVED') {
                    msg = 'El presupuesto ya fue aprobado';
                }
                this.simpleError(msg);
            });
        });
    }

    pdf() {
        let url = `${Config.publicUrl}/api/Quotes/pdf?id=${this.model.id}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
        if (this.selectedProceduresList) {
            url += `&procedureIds=[${this.selectedProceduresList.join(',')}]`;
        }
        this.$window.open(url);
    }

    newVehicle(ev, initialPlate) {
        this.searchVehicleText = '';
        this.$mdDialog.show({
            controller: NewVehicleController,
            template: NewVehicleTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen,
            locals: {
                initialPlate: initialPlate,
                VehiclesService: this.VehiclesService
            }
        }).then(data => {
            this.showNewVehicleSpin = true;
            let newVehicle = this.VehiclesService.create(data.vehicle);
            return this.VehiclesService.save(newVehicle);
        }).then(vehicle => {
            // AGAIN MF fullDesc HACK
            vehicle.fullDesc = `${vehicle.plate} - ${vehicle.number} - \
${vehicle.description}`;
            this.simpleSuccess(`El nuevo vehiculo ha sido creado
 correctamente`);
            this.showNewVehicleSpin = false;
            this.selectedVehicleChange(vehicle);
        });
    }

    getClientName(client) {
        return client.lastName + ' ' + client.name;
    }

    addSpending(ev) {
        let spendingsPromise = this.OperativeSpendingsService.findAssociable({
            where: {
                or: [{
                    holderId: this.model.holderId
                }, {
                    vehicleId: this.model.vehicleId
                }, {
                    quoteId: this.model.id
                }]
            },
            include: ['collection']
        });
        this.$mdDialog.show({
            controller: AddSpendingController,
            template: AddSpendingTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen, // Only for -xs, -sm breakpoints.,
            locals: {
                spendingsPromise: spendingsPromise
            }
        }).then(data => {
            this.associatingSpending = data.oSpending;
            this.associatingSpendingItems = {};
            this.totalAssociatedAmount = 0;
            this.cannotSave = true;
            this.$scope.$broadcast('associationStart');
        }, err => {
            // dialog cancelled
        }).then(() => {

        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    onUpdateAssociatedAmount($event) {
        let item = $event.item,
            associatedAmount = $event.associatedAmount;
        this.associatingSpendingItems[item.id] = associatedAmount;
        this.totalAssociatedAmount = Object.keys(this.associatingSpendingItems)
            .map((id) => this.associatingSpendingItems[id])
            .reduce((accum, val) => accum + val, 0);
    }

    saveAssociation() {
        this.showSaveAssociationSpin = true;
        this.OperativeSpendingsService.associate({
            id: this.associatingSpending.id,
            quoteId: this.model.id,
            associations: Object.keys(this.associatingSpendingItems)
                .map((id) => {
                    let ret = {};
                    ret[id] = this.associatingSpendingItems[id];
                    return ret;
                })
        }).then((res) => {
            let index = this.pendingOperativeSpendings.findIndex(
                o => o.id == this.associatingSpending.id
            );
            if (index > -1) {
                this.pendingOperativeSpendings.splice(index, 1);
            }

            this.showSaveAssociationSpin = false;
            this.associatingSpending = null;
            this.cannotSave = false;
            this.simpleSuccess();
            this.operativeSpendings.push(res.spending);

            let osItems = res.osItems;
            osItems.forEach(osItem => {
                let item = this.getItemById(osItem.itemId);
                osItem.operativeSpending = res.spending;
                item.osItems.push(osItem);
                this.$scope.$broadcast('associationSave', item.id);
            });
        }, err => {
            this.showSaveAssociationSpin = false;
            this.associatingSpending = null;
            this.cannotSave = false;
            this.cancelAssociation();
            raven.captureException(new Error(err));
            this.simpleError();
        });
    }

    cancelAssociation() {
        this.$scope.$broadcast('associationCancel');
        this.associatingSpending = null;
        this.cannotSave = false;
    }

    afterReset() {
        this.cancelAssociation(); // just in case
    }

    markNotInvoiceable(ev) {
        var confirm = this.$mdDialog.prompt()
            .title('Marcar como no facturable')
            .textContent(`Esto marcará la OT como no facturable y dejará de
aparecer como disponible en remitos. Ingrese el motivo.`)
            .placeholder('Motivo')
            .ariaLabel('Motivo')
            .required(true)
            .targetEvent(ev)
            .ok('Marcar como no facturable')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(result => {
            this.model.$prototype$markNotInvoiceable({
                reason: result
            }).then((res) => {
                Object.assign(this.model, res.quote);
            });
        });
    }

    onSelectedProceduresChange($event) {
        this.selectedProceduresList = Object.keys(this.selectedProcedures)
            .filter(pId => this.selectedProcedures[pId]);
    }
}

export default QuoteController;
